module.exports = __webpack_public_path__ + "img/p1.ffd74625.svg";